var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "mc-main" },
        [
          _c(
            "a-card",
            { attrs: { title: "网络舆情监控系统", avatar: "global" } },
            [_vm._t("default", [_c("router-view")])],
            2
          )
        ],
        1
      ),
      _c("IndexFooter")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mc-header" }, [
      _c("div", { staticClass: "mc-header-title" }, [
        _vm._v("网络舆情监控系统")
      ]),
      _c("img", {
        staticClass: "mc-header-logo",
        attrs: { src: require("@/images/logo.png") }
      }),
      _c("img", {
        staticStyle: { width: "1000px" },
        attrs: { src: require("../../images/index.jpg") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }